import { getAdditionalCost } from '../apicalls/estimates';

export const fetchAdditionalCost = (
  estimateId: number,
  setAdditionalParam: any
) => {
  getAdditionalCost(estimateId).then(data => {
    let res = data.additional_cost;
    if (res) {
      setAdditionalParam({
        id: res.id,
        additionalCost: res.additional_cost,
        finalGrossProfitMargin: res.final_gross_profit_margin
      });
    }
  });
};
